import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../components/icon/Icon';
import { RootState } from '../../../core/state/state';
import Image from '../../../components/image/Image';

import './ProfileInfo.scss';

interface Props {
  img?: string;
}

const ProfileInfo: React.FC<Props> = ({ img }) => {
  const account = useSelector((state: RootState) => state.auth.authInfo?.account);
  return (
    <div className="project-info-box">
      <div className="project-info-box__image">
        {img ? <Image src={img} alt="project info image" /> : <Icon size="full-size" icon="projectsRed" className="project info icon" />}
      </div>
      <div className="project-info-box__info">
        <div className="project-info-box__name">{account?.name}</div>
      </div>
    </div>
  );
};

export default ProfileInfo;
